/* CNOIR card gallery (2026-10-18). Delegated, so cards added later (filters, sort, load more) work too. */
(function () {
  if (window.__ccg) return; window.__ccg = true;
  function sync(track) {
    var g = track.closest('[data-ccg]'); if (!g) return;
    var w = track.clientWidth || 1, n = track.children.length;
    var i = Math.min(n - 1, Math.max(0, Math.round(track.scrollLeft / w)));
    var dots = g.querySelectorAll('.ccg-dots i');
    for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('on', k === i);
    var p = g.querySelector('[data-ccg-prev]'), x = g.querySelector('[data-ccg-next]');
    if (p) p.disabled = i === 0;
    if (x) x.disabled = i >= n - 1;
  }
  var raf = 0;
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-ccg-track]')) return;
    clearTimeout(raf); raf = setTimeout(function () { sync(t); }, 50);
  }, true);
  document.addEventListener('scrollend', function (e) { var t = e.target; if (t && t.matches && t.matches('[data-ccg-track]')) sync(t); }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ccg-prev],[data-ccg-next]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var track = b.closest('[data-ccg]').querySelector('[data-ccg-track]');
    var dir = b.hasAttribute('data-ccg-next') ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
  }, true);
  function init() { document.querySelectorAll('[data-ccg-track]').forEach(sync); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
